export default __webpack_public_path__ + "static/media/JustinWaldron.8dcd2a11.png";